import { Drawer, Hidden, MuiThemeProvider, withStyles } from "@material-ui/core";
import NavbarMobileLayout2 from "app/Configs/fuse-layouts/layout2/components/NavbarMobileLayout2";
import * as Actions from "app/store/actions";
import React from "react";
import connect from "react-redux/es/connect/connect";
import { bindActionCreators } from "redux";

const navbarWidth = 280;

const styles = (theme) => ({
   navbar: {
      display: "flex",
      overflow: "hidden",
      height: 64,
      minHeight: 64,
      alignItems: "center",
      boxShadow: theme.shadows[3],
      zIndex: 6,
   },
   navbarMobile: {
      display: "flex",
      overflow: "hidden",
      flexDirection: "column",
      width: navbarWidth,
      minWidth: navbarWidth,
      height: "100%",
      zIndex: 4,
      transition: theme.transitions.create(["width", "min-width"], {
         easing: theme.transitions.easing.sharp,
         duration: theme.transitions.duration.shorter,
      }),
      boxShadow: theme.shadows[3],
   },
});

const NavbarWrapperLayout2 = ({ classes, navbarTheme, children, navbar, navbarOpenFolded, navbarCloseFolded, navbarCloseMobile }) => {
   return (
      <MuiThemeProvider theme={navbarTheme}>
         <Drawer
            anchor="right"
            variant="temporary"
            open={navbar.mobileOpen}
            classes={{
               paper: classes.navbarMobile,
            }}
            onClose={navbarCloseMobile}
            ModalProps={{
               keepMounted: true, // Better open performance on mobile.
            }}
         >
            <NavbarMobileLayout2 />
         </Drawer>
      </MuiThemeProvider>
   );
};

function mapDispatchToProps(dispatch) {
   return bindActionCreators(
      {
         navbarOpenFolded: Actions.navbarOpenFolded,
         navbarCloseFolded: Actions.navbarCloseFolded,
         navbarCloseMobile: Actions.navbarCloseMobile,
      },
      dispatch
   );
}

function mapStateToProps({ fuse }) {
   return {
      navbarTheme: fuse.settings.navbarTheme,
      navbar: fuse.navbar,
   };
}

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(NavbarWrapperLayout2));
